var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.385,
    height: 45.385,
    viewBox: "0 0 45.385 45.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1369",
    "data-name": "Raggruppa 1369",
    transform: "translate(2146.926 -848.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1339",
    "data-name": "Raggruppa 1339",
    transform: "translate(-3056.926 585.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_94_3",
    "data-name": "Componente 94 \\u2013 3",
    transform: "translate(910 263.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_869",
    "data-name": "Rettangolo 869",
    width: 45.385,
    height: 45.385
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1804",
    "data-name": "Tracciato 1804",
    d: "M14.5,19.3c-2.183,2.39-4.313,4.722-6.443,7.053-1.111,1.215-2.22,2.433-3.341,3.64a.9.9,0,0,1-.509.327c-1.2.029-2.395.015-3.781.015L12.7,16.888C8.479,11.274,4.281,5.7,0,.009H.694C3.776.009,6.858.016,9.94,0A.947.947,0,0,1,10.8.434q3.643,4.86,7.317,9.7c.092.122.194.236.34.412.3-.32.6-.615.879-.921Q23.586,5,27.824.368A1.008,1.008,0,0,1,28.673,0c1.1.02,2.2.007,3.475.007L20.262,12.98l13.013,17.3c-.25.021-.411.047-.571.047-3.1,0-6.2,0-9.3.01a1.015,1.015,0,0,1-.915-.464Q18.7,24.83,14.895,19.8c-.115-.152-.235-.3-.394-.506ZM28.468,28.04c-.179-.257-.283-.415-.4-.566C22.1,19.549,16.115,11.641,10.194,3.682A2.765,2.765,0,0,0,7.353,2.267a18.768,18.768,0,0,1-2.505.02c.165.241.244.368.335.487Q9.429,8.417,13.675,14.06q5.122,6.8,10.257,13.6a.916.916,0,0,0,.58.368c1.277.033,2.555.017,3.953.017Z",
    transform: "translate(6.138 7.729)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b0ea3e0900c46c356a6165f147b22480.svg";
export { ForwardRef as ReactComponent };